import { useState } from 'react';

const RemoveTaskPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showRemoveTaskPopup, setShowRemoveTaskPopup] =
      useState<boolean>(false);

    const removeTaskToggleHandler = () => {
      localStorage.setItem('images', JSON.stringify([]));
      setShowRemoveTaskPopup(!showRemoveTaskPopup);
    };

    return (
      <Component
        showRemoveTaskPopup={showRemoveTaskPopup}
        removeTaskToggleHandler={removeTaskToggleHandler}
        {...props}
      />
    );
  };

export default RemoveTaskPopupHOC;
